import platform from 'platform';

export default platform.name === 'IE' || platform.name === 'Microsoft Edge';